import React from "react";
import AdminLineItem from "@/components/AdminLineItem";
import { FileUpload, EditableMessageCard } from "@/components";
import { useUser } from "../useUser";

export default function FileUploadPage() {
  const user = useUser();

  return (
    <AdminLineItem title="Document Upload" user={user}>
      <div className="container">
        <h1 style={{ color: "#F16D09", paddingBottom: "2.5rem", marginTop: "3rem" }}>
          Document Upload
        </h1>

        <p className="lead mb-5">
          Upload PDF documents that will be available to platform users. Changes take effect immediately.
        </p>

        {/* Row 1 - Terms & Conditions + Help File */}
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card p-3 h-100">
              <h4 style={{ marginTop: 0, color: "#F16D09" }}>Upload Terms & Conditions PDF</h4>
              <p className="text-muted">
                Upload your terms and conditions PDF file. If the file changes, upload the new version here.
                It will automatically update the terms shown to users on their first login, and will re-show them
                to all users on their next login after any change is made.
              </p>
              <FileUpload
                endpoint="/api/files/Terms"
                fileTypeLabel="Terms & Conditions PDF"
                successMessage="Terms & Conditions uploaded successfully"
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="card p-3 h-100">
              <h4 style={{ marginTop: 0, color: "#F16D09" }}>Upload Help File PDF</h4>
              <p className="text-muted">
                Upload a help guide PDF for members. This file will be accessible to all logged-in users
                from the Help button in their portal menu bar.
              </p>
              <FileUpload
                endpoint="/api/files/Help"
                fileTypeLabel="Help File PDF"
                successMessage="Help file uploaded successfully"
              />
            </div>
          </div>
        </div>

        {/* Row 2 - Privacy Policy */}
        <div className="row g-4 mt-4">
          <div className="col-md-6">
            <div className="card p-3 h-100">
              <h4 style={{ marginTop: 0, color: "#F16D09" }}>Upload Privacy Policy PDF</h4>
              <p className="text-muted">
                Upload a privacy policy PDF for members. This file will be accessible to all users
                from the Privacy Policy link in the footer.
              </p>
              <FileUpload
                endpoint="/api/files/Privacy"
                fileTypeLabel="Privacy Policy PDF"
                successMessage="Privacy Policy uploaded successfully"
              />
            </div>
          </div>
        </div>

        {/* Row 3 - Welcome Message (editor + preview in one card) */}
        <div className="row g-4 mt-4">
          <div className="col-12">
            <EditableMessageCard
              cardTitle="Manage Welcome Message"
              description="Set a welcome message that appears on the users dashboard."
              getEndpoint="/api/configurablemessage/welcomemessage"
              saveEndpoint="/api/configurablemessage/welcomemessage"
              savedMessageLabel="Current Saved Welcome Message"
              saveButtonLabel="Save Welcome Message"
              deleteButtonLabel="Delete Welcome Message"
            />
          </div>
        </div>

        {/* Row 4 - Reports Offline Message */}
        <div className="row g-4 mt-4">
          <div className="col-12">
            <EditableMessageCard
              cardTitle="Manage Reports Offline Message"
              description="Set the message shown to users when they try to access reports and the Power BI service is currently offline."
              getEndpoint="/api/configurablemessage/reportsmessage"
              saveEndpoint="/api/configurablemessage/reportsmessage"
              savedMessageLabel="Current Saved Reports Offline Message"
              saveButtonLabel="Save Reports Offline Message"
              deleteButtonLabel="Delete Reports Offline Message"
            />
          </div>
        </div>
      </div>
    </AdminLineItem>
  );
}
